export default "__VITE_ASSET__CPkJxqgm__"